export function initials(name: string): string {
  if (!name) return "?";
  const cleaned = name.replace(/^(Dr\.|Conf\. Dr\.|Prof\. Dr\.|As\.|As\. șef)\s*/i, "").trim();
  const parts = cleaned.split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
}

export function firstName(name: string): string {
  return name.replace(/^(Dr\.|Conf\. Dr\.|Prof\. Dr\.|As\.|As\. șef)\s*/i, "").split(/\s+/)[0] || name;
}

export function fmtDuration(minutes: number | null | undefined): string {
  if (!minutes) return "—";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m} min`;
}

export function fmtScore(score: number | null | undefined): string {
  return score == null ? "—" : Number(score).toFixed(1);
}

const COVER_GRADIENTS = [
  "linear-gradient(135deg, #009ab0, #00657b)",
  "linear-gradient(135deg, #00657b, #003e4d)",
  "linear-gradient(135deg, #f61946, #b30e30)",
  "linear-gradient(135deg, #14a36a, #0a6e47)",
  "linear-gradient(135deg, #5a3aa0, #2f1e63)",
  "linear-gradient(135deg, #0086a4, #00657b)",
];

export function coverFor(course: { slug?: string; id?: string; cover_image_url?: string | null }): string {
  if (course.cover_image_url) return `url('${course.cover_image_url}') center/cover`;
  let h = 0;
  for (const c of course.slug || course.id || "") h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return COVER_GRADIENTS[h % COVER_GRADIENTS.length];
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
